// [시작: src/store/index.js 전체 코드 작성]
import { createStore } from 'vuex';

export default createStore({
  state: {
    user: null // 로그인한 회원 정보를 담을 상태값
  },
  getters: {
    isAuthenticated: state => !!state.user,
    currentUser: state => state.user
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    clearUser(state) {
      state.user = null;
    }
  },
  actions: {
  },
  modules: {
  }
});
// [끝: src/store/index.js 전체 코드 작성]